
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>Podcast Category List</h4>
            <!-- {{ Categories.data }} -->
            <!-- <h6>Manage Your Subscription Plans</h6> -->
          </div>
        </div>
        <ul class="table-top-head">

          <li>
            <a
                ref="collapseHeader"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Collapse"
                @click="toggleCollapse(collapseHeader.value)"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a
              v-if="canAddNewPodcastCategory"
              href="javascript:void(0);"
              class="btn btn-added"
              @click="openModal('new')"
          ><vue-feather type="plus-circle" class="me-2"></vue-feather>Add New Podcast Category
          </a>
        </div>
      </div>
      <!-- USER TABLE -->
      <filter-table
          :extra-class="['table', 'datanew']"
          :columns="PodcastCategories.columns"
          :data="PodcastCategories.data.value"
          :filters="PodcastCategories.filters"
      >
        <template #header>
          <h4>Available Categories</h4>
        </template>
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'action'">
            <td class="action-table-data">
              <div class="edit-delete-action">
                <a @click="openModal('update', record.id)" class="me-2 p-2 mb-0">
                  <i data-feather="edit" class="feather-edit"></i>
                </a>
                <a
                    @click="deleteCategory(record.id)"
                    class="me-2 confirm-text p-2 mb-0"
                    href="javascript:void(0);"
                >
                  <i data-feather="trash-2" class="feather-trash-2"></i>
                </a>
              </div>
            </td>
          </template>
        </template>

        <!-- </template> -->
      </filter-table>
      <!-- USER TABLE -->
    </div>
  </div>
  <PodcastCatModal :category-id="selectedCategoryId" ref="podcastCatModal"/>


</template>

<script setup>

import PodcastCatModal from "./modal/podcast-category-modal.vue";
import {computed, onMounted, ref} from "vue";
import {usePodcastCategoryStore} from "@/store/podcastCategoryStore";
import {confirm} from "@/utils/swal";
import {toggleCollapse} from "@/utils/components";


const podcastCategoryStore = usePodcastCategoryStore();

// data
/**
 * Id of Plan that is being edited
 */
const selectedCategoryId = ref(null);
const PodcastCategories = {
  filters: ["name"],
  columns: [
    {
      title: "Podcast Category",
      dataIndex: "name",
      key: "name",
      sorter: {
        compare: (a, b) => {
          a = a.name.toLowerCase();
          b = b.name.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: {
        compare: (a, b) => {
          a = a.description.toLowerCase();
          b = b.description.toLowerCase();
          return a > b ? -1 : b > a ? 1 : 0;
        },
      },
    },
    {
      title: "Created On",
      dataIndex: "created_on",
      key: "created_on",
      sorter: true,
    },
    {
      title: "Action",
      key: "action",
      sorter: true,
    },
  ],
  data: computed(() => podcastCategoryStore.podcastCategories),
};

// const canAddNewPodcastCategory = computed(() => podcastCategoryStore.podcastCategories.length < 10);

const canAddNewPodcastCategory = computed(() => {
  return Array.isArray(podcastCategoryStore.podcastCategories)
      ? podcastCategoryStore.podcastCategories.length < 10
      : false;
});



// ref elements
const collapseHeader = ref(null);
const podcastCatModal = ref(null);
// Methods
async function deleteCategory(id) {
  confirm({
    title: "Are you sure about this?",
    message: "This category and all its podcasts attached to it will be deleted",
    callback: async (continueDelete) => {
      if (continueDelete) {
        await podcastCategoryStore.deletePodcastCategory(id);
      }
    },
  });
}

function openModal(action, id = null) {
  if (action == "update") {
    selectedCategoryId.value = id;
  } else {
    selectedCategoryId.value = null;

  }
  $("#podcastCatModal").modal("show");
}

onMounted(async () => {
  if (PodcastCategories.data.value.length === 0) {
    await podcastCategoryStore.fetchPodcastCategories();
  }
});


</script>

<style scoped>

</style>